import axios from '@/js/plugins/client'

export default {
  alias      : 'tramite_documento',
  route      : '/app/tramite/documento',
  hash       : false,
  store      : false,
  key        : 'iddocumento',
  selectable : false,
  relations  : [
    {
      attribute : 'docu_iddependencia',
      alias     : 'dependencia',
      module    : 'dependencia',
    },
  ],
  default : {
    iddocumento               : null,
    docu_origen               : null,
    docu_tipo                 : null,
    docu_idprioridad          : null,
    docu_forma                : null,
    docu_iddependencia        : null,
    docu_ruc                  : null,
    docu_detalle              : null,
    docu_firma                : null,
    docu_cargo                : null,
    docu_idtipodocumento      : null,
    docu_fecha_doc            : null,
    docu_numero_doc           : null,
    docu_siglas_doc           : null,
    docu_proyectado           : null,
    docu_idrecepcion          : null,
    docu_folios               : null,
    docu_asunto               : null,
    docu_relacionado          : null,
    docu_idusuario            : null,
    docu_idusuariodependencia : null,
    docu_emailorigen          : null,
    docu_archivo              : [],
    docu_estado               : null,
    docu_clastupa             : null,
    docu_diasatencion         : null,
    docu_idtdoc               : null,
    docu_numtdoc              : null,
    docu_idtupa               : null,
    docu_idexma               : null,
    docu_domic                : null,
    docu_dni                  : null,
    docu_telef                : null,
    docu_doc_generado         : null,
    docu_firma_electronica    : null,
    docu_contrasenia          : null,
    docu_token                : null,
    created_at                : null,
    updated_at                : null,
    docu_digital              : null,
    docu_referencias          : null,
    cui_proyecto              : null,
    tipo_tramite              : null,
    plazo                     : null
  },
  methods : {
    save(params) {
      return axios.post('/tramite/documento', params)
    },
  }
}
